import { render, staticRenderFns } from "./PhanTichDienNuocChiTiet.vue?vue&type=template&id=cc5bdb44&scoped=true"
import script from "./PhanTichDienNuocChiTiet.vue?vue&type=script&lang=js"
export * from "./PhanTichDienNuocChiTiet.vue?vue&type=script&lang=js"
import style0 from "./PhanTichDienNuocChiTiet.vue?vue&type=style&index=0&id=cc5bdb44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5bdb44",
  null
  
)

export default component.exports